import { Component, OnInit, signal, ChangeDetectionStrategy } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TrimSpacesDirective } from '@directives/trim-spaces.directive';
import { EditorComponentBase } from 'ngx-lib';
import { ValidationErrorMessageComponent } from '../../validation-error-message/validation-error-message.component';

@Component({
    selector: 'app-text-input-editor',
    templateUrl: './text-input-editor.component.html',
    styleUrls: ['./text-input-editor.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [FormsModule, ValidationErrorMessageComponent, TrimSpacesDirective]
})
export class TextInputEditorComponent extends EditorComponentBase<string> implements OnInit {
    shouldTrimSpaces = signal(false);
    showOnlyFirstError = signal(false);

    constructor() {
        super();
    }

    ngOnInit(): void {
        this.shouldTrimSpaces.set(!!this.additionalInfo?.shouldTrimSpaces);
        this.showOnlyFirstError.set(!!this.additionalInfo?.showOnlyFirstError);
    }

    dataChanged() {
        this.valueChange.emit();
        this.validate();
    }
}
